import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from './axiosBaseQuery';

export const baseApi = createApi({
	reducerPath: 'api',
	baseQuery: axiosBaseQuery(),
	tagTypes: ['TableData', 'Clients', 'Suppliers', 'Products', 'Orders', 'Invoices'],
	endpoints: () => ({}),
});
